/**
 * Audit C3 fix 2026-06-03 (CRITICAL): estrazione share_token da URL viewer.
 *
 * Pattern URL supportati:
 *   - https://viewer.oniri.space/?share=<token>          (share link pubblico)
 *   - https://viewer.oniri.space/?share_token=<token>    (alias esplicito)
 *
 * Il token, se presente, viene propagato a tutte le chiamate API dei 4
 * endpoint pubblici del viewer (/api/model/:id, /hotspots, /presets,
 * /floorplan) per superare il gate backend
 * `assertPublicModelAccessWithShareToken`.
 *
 * Helper puro (no DOM access) per essere testabile in unit test:
 * accetta uno string href, ritorna il token o null.
 */

const VALID_TOKEN_REGEX = /^[A-Za-z0-9_-]{16,128}$/;

/**
 * Estrae lo share_token da un href URL. Ritorna null se non presente o
 * malformato. Tollerante a URL invalido (URL constructor throws → null).
 */
export function extractShareTokenFromUrl(href: string): string | null {
  let url: URL;
  try {
    url = new URL(href);
  } catch {
    return null;
  }
  const raw =
    url.searchParams.get('share_token') ?? url.searchParams.get('share');
  if (raw === null) return null;
  if (!VALID_TOKEN_REGEX.test(raw)) return null;
  return raw;
}
